const REPORT_TYPE_NAMES = [
  "Общие",
  "Клиенты",
  "Кабинеты",
  "Продажи",
  "Платежи",
  "Документы",
  "Виды карт",
  "Карты",
  "Сертификаты",
  "Аренда объектов",
  "Чек ККМ",
  "Быстрые продажи",
  "Регистрация питания",
  "Накладные",
  "Журнал движений СКД",
  "Исследования"
];

export const LEGACY_REPORT_TYPES = REPORT_TYPE_NAMES.map((name, value) => ({
  value,
  label: `${name} (устар.)`,
  legacy: true
}));

const ONLINE_ONLY_REPORT_TYPE_NAMES = ["Карта питания"];

export const ONLINE_REPORT_TYPES = [
  ...REPORT_TYPE_NAMES.map((name, index) => ({ value: index + 100, label: name, legacy: false })),
  ...ONLINE_ONLY_REPORT_TYPE_NAMES.map((name, index) => ({
    value: REPORT_TYPE_NAMES.length + index + 100,
    label: name,
    legacy: false
  }))
];

export const REPORT_TYPES = [...LEGACY_REPORT_TYPES, ...ONLINE_REPORT_TYPES];

export const REPORT_VID = {
  CLIENTS: 101,
  CABINETS: 102,
  TRAVEL: 103,
  PAYMENTS: 104,
  NUTRITION_REGISTRATION: 112,
  WAREHOUSE_DOCUMENTS: 113,
  NUTRITION_MAP: 116
};

export const getReportTypeLabel = (value) =>
  REPORT_TYPES.find((item) => item.value === Number(value))?.label ?? String(value ?? "");

export const isLegacyReportType = (value) => {
  const n = Number(value);
  return Number.isFinite(n) && n >= 0 && n <= 15;
};
